angular.module('clientDashboardApp').controller("NotificationSettingsCtrl", ($scope, $http) => {
  $scope.loading = true;
  $scope.settings = {
    workflow: {}
  };

  $scope.onWorkflowSettingToggle = () => {
    $http.post('/user/notifications/settings', $scope.settings.workflow);
  };

  //
  $http.get('/user/notifications/settings').then(response => {
    $scope.loading = false;
    let settings = response.data.settings
    addIfUndefined(settings, ['TaskAssigned', 'TaskEdited', 'TaskComment'])
    $scope.settings.workflow = settings;
  });

  // not ideal but initial fields are undefined which is on so update the response to view can be bound to the data
  function addIfUndefined(settings, keys) {
    keys.forEach(key =>
    {
      if(typeof settings.emailsEnabled[key] === 'undefined'){
        settings.emailsEnabled[key] = true;
      }
    })
  }
});
